export const formatNumberWithCommas = (number) => {
  if (isNaN(number)) {
    return '';
  }
  number = Math.round(number);
  const parts = number.toString().split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1] || '';
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
};
